<svg
  width="17"
  height="17"
  viewBox="0 0 17 17"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.0212 12.535C12.751 11.3748 14.0235 8.22136 12.8633 5.49152C11.7032 2.76168 8.54972 1.4892 5.81988 2.64936C3.09005 3.80951 1.81757 6.96297 2.97772 9.69281C4.13787 12.4226 7.29133 13.6951 10.0212 12.535Z"
    stroke="#111111"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M11.7178 11.3896L15.8832 15.5556"
    stroke="#111111"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
